(function () {
  function reveal() {
    const nodes = document.querySelectorAll(".zohar-reveal");
    if (!nodes.length) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      nodes.forEach((n) => n.classList.add("is-in"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    nodes.forEach((n) => io.observe(n));
  }

  function stickyHeader() {
    document.querySelectorAll(".zohar-header").forEach((header) => {
      let scrolled = false;
      let ticking = false;
      const targets = [header, header.closest(".zohar-header-section"), header.closest(".shopify-section")].filter(Boolean);
      const apply = () => {
        ticking = false;
        const y = window.scrollY || document.documentElement.scrollTop || 0;
        const next = scrolled ? y > 2 : y > 8;
        if (next === scrolled) return;
        scrolled = next;
        targets.forEach((el) => {
          el.classList.toggle("is-scrolled", scrolled);
          el.classList.toggle("reduce-logo-size", scrolled);
        });
      };
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(apply);
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      document.addEventListener("scroll", onScroll, { passive: true, capture: true });
      apply();
    });
  }


  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      reveal();
      stickyHeader();
    });
  } else {
    reveal();
    stickyHeader();
  }
})();
